import { render, staticRenderFns } from "./booking-calendar.vue?vue&type=template&id=7670112d&scoped=true&"
import script from "./booking-calendar.ts?vue&type=script&lang=ts&"
export * from "./booking-calendar.ts?vue&type=script&lang=ts&"
import style0 from "./booking-calendar.scss?vue&type=style&index=0&id=7670112d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670112d",
  null
  
)

export default component.exports